// extracted by mini-css-extract-plugin
export default {"hero":"Header_hero__GBdKj","show":"Header_show__nWK+2"};